import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  Container,
  Grid,
  Snackbar,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CityConfigServices from "../services/externalServices/cityConfigServices";
import { Link } from "react-router-dom";
import { Edit, Delete, Add } from "@mui/icons-material";

function CityConfig() {
  const [cityConfig, setCityConfig] = useState({
    city: "",
    minimumCharge: "",
    additionalCharge: "",
    longitude: "",
    latitude: "",
    block: "",
  });
  const [cityConfigs, setCityConfigs] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [addCityConfig, setAddCityConfig] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cityToDelete, setCityToDelete] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCityConfig({ ...cityConfig, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        const response = await CityConfigServices.updateCityCponfig(editId, cityConfig);
        if (response) {
          setSnackbarMessage("City config updated successfully");
        } else {
          console.error("Failed to update city config");
        }
      } else {
        const response = await CityConfigServices.addCityConfig(cityConfig);
        if (response) {
          setSnackbarMessage("City config added successfully");
        } else {
          console.error("Failed to add city config");
        }
      }
      setSnackbarOpen(true);
      setCityConfig({
        city: "",
        minimumCharge: "",
        additionalCharge: "",
        longitude: "",
        latitude: "",
        block: "",
      });
      fetchCityConfigs();
      setAddCityConfig(false);
      setEditMode(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEdit = (city) => {
    setCityConfig(city);
    setEditMode(true);
    setEditId(city._id);
    setAddCityConfig(true);
  };

  const handleClickOpenDialog = (city) => {
    setCityToDelete(city._id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCityToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (cityToDelete) {
      try {
        const response = await CityConfigServices.deleteCityConfig(cityToDelete);
        if (response) {
          setSnackbarMessage("City config deleted successfully");
          setSnackbarOpen(true);
          fetchCityConfigs();
        } else {
          console.error("Failed to delete city config");
        }
      } catch (error) {
        console.error("Error deleting city config:", error);
      }
    }
    handleCloseDialog();
  };

  useEffect(() => {
    fetchCityConfigs();
  }, []);

  const fetchCityConfigs = async () => {
    try {
      const response = await CityConfigServices.getCityConfig();
      setCityConfigs(response);
    } catch (error) {
      console.error("Error fetching city configs:", error);
    }
  };

  return (
    <Container>
      <nav>
        <ol className="breadcrumb d-none d-lg-flex ms-3">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
          </li>
          <li className="breadcrumb-item opacity-50">CityConfig</li>
        </ol>
      </nav>
      {addCityConfig && (
        <Container>
          <Typography variant="h4" gutterBottom>
            {editMode ? "Edit the CityConfig" : "Add City Config"}
          </Typography>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                setAddCityConfig(false);
              }}
            >
              back
            </Button>
          </Grid>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  value={cityConfig.city}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Minimum Charge"
                  name="minimumCharge"
                  value={cityConfig.minimumCharge}
                  onChange={handleChange}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Additional Charge"
                  name="additionalCharge"
                  value={cityConfig.additionalCharge}
                  onChange={handleChange}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Longitude"
                  name="longitude"
                  value={cityConfig.longitude}
                  onChange={handleChange}
                  required
                  // type="number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Latitude"
                  name="latitude"
                  value={cityConfig.latitude}
                  onChange={handleChange}
                  required
                  // type="number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Block"
                  name="block"
                  value={cityConfig.block}
                  onChange={handleChange}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Service Type"
                  name="serviceType"
                  value={cityConfig.serviceType}
                  onChange={handleChange}
                  type="string"
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">
                  {editMode ? "Update" : "Add"}
                </Button>
              </Grid>
            </Grid>
          </form>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          />
        </Container>
      )}
      {!addCityConfig && (
        <Container>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setAddCityConfig(true);
              }}
            >
              Add City Config
            </Button>
          </Grid>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>City</TableCell>
                  <TableCell>Minimum Charge</TableCell>
                  <TableCell>Additional Charge</TableCell>
                  <TableCell>Longitude</TableCell>
                  <TableCell>Latitude</TableCell>
                  <TableCell>Block</TableCell>
                  <TableCell>Service Type</TableCell>
                  <TableCell>Actions</TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {cityConfigs.map((city) => (
                  <TableRow key={city._id}>
                    <TableCell>{city.city}</TableCell>
                    <TableCell>{city.minimumCharge}</TableCell>
                    <TableCell>{city.additionalCharge}</TableCell>
                    <TableCell>{city.longitude}</TableCell>
                    <TableCell>{city.latitude}</TableCell>
                    <TableCell>{city.block}</TableCell>
                    <TableCell>{city.serviceType}</TableCell>
                    <TableCell>
                    <span style={{ cursor: "pointer", marginRight: "15px" }}>
                        <Edit
                          variant="contained"
                          color="primary"
                          onClick={() => handleEdit(city)}
                        />
                      </span>
                      <span style={{ cursor: "pointer" }}>
                        <Delete
                          variant="contained"
                          color="danger"
                          onClick={() => handleClickOpenDialog(city)}
                        />
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this city?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default CityConfig;
